import script from "./ProfileSeasonsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSeasonsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSeasonsSection.vue?vue&type=style&index=0&id=2aa0307a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa0307a"]])

export default __exports__